// @ts-strict-ignore
import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppcloudCountsService } from 'projects/appcloud-admin-portal/src/app/services/appcloud-counts.service';
import { SpinnerService } from 'projects/internal/r1-component-library/src/lib/services';
import { MetricsCard } from 'projects/appcloud-admin-portal/src/app/models/metrics-card.model';
import { MetricsSingleDatapointComponent } from './metrics-single-datapoint/metrics-single-datapoint.component';
import { LoadingSpinnerComponent } from 'projects/internal/r1-component-library/src/lib/components/loading-spinner/loading-spinner.component';
import { AsyncPipe } from '@angular/common';

/** Home KPI row (prototype: four light-weight blue figures on white tiles, responsive CSS grid). */
@Component({
    selector: 'r1-metrics-dashboard',
    templateUrl: './metrics-dashboard.component.html',
    styleUrls: ['./metrics-dashboard.component.scss'],
    imports: [MetricsSingleDatapointComponent, LoadingSpinnerComponent, AsyncPipe],
})
export class MetricsDashboardComponent implements OnInit {
    readonly #appcloudCountsService = inject(AppcloudCountsService);
    readonly #spinnerService = inject(SpinnerService);

    isLoading$: Observable<boolean> = this.#spinnerService.isLoading();
    loadingMessages$: Observable<string[]> = this.#spinnerService.getMessages();

    public cards: MetricsCard[] = [];

    ngOnInit() {
        this.#appcloudCountsService.getMetricsCards().subscribe(cards => (this.cards = cards));
    }
}
